<main class="main">
  <div class="content">
    <div class="logo">
      <img alt="" src="assets/img/backstage-logo.svg" />
    </div>
  </div>
</main>
